import type { FC } from 'react';
import { HelpCaption } from '../capations/help-caption';
import { HelpCaptionDescription } from '../capations/help-caption-description';
import { SupportTitle } from '../capations/support-title';
import { WistiaPlayer } from '../player/wistia-player';

const PLAYER_HEIGHT = '533px';
// cspell:ignore yu1wepwbl2 594qlua2gp
const OVERVIEW_MEDIA_ID = 'yu1wepwbl2';
const CREATION_MEDIA_ID = '594qlua2gp';

export const PurchaseOrderHelpCenterContent: FC = () => {
  return (
    <div className="d-flex flex-direction-column">
      <SupportTitle />
      <HelpCaption>Supplier Module Overview</HelpCaption>
      <HelpCaptionDescription>
        This video gives a clear overview of the Purchase Order user interface. It will explain how to navigate the
        system, create and manage purchase orders, and Shipment order statuses.
      </HelpCaptionDescription>
      <WistiaPlayer mediaId={OVERVIEW_MEDIA_ID} height={PLAYER_HEIGHT} />
      <HelpCaption>Supplier Shipment Creation</HelpCaption>
      <HelpCaptionDescription>
        In this video, we will thoroughly explore the shipment creation functionality within the Supplier module. We
        will cover step-by-step instructions on how to create, manage, and track shipments, as well as discuss key
        features such as selecting suppliers, inputting shipment details. By the end of this tutorial, you will have a
        comprehensive understanding of how to effectively utilize the shipment creation tools to streamline your supply
        chain processes.
      </HelpCaptionDescription>
      <WistiaPlayer mediaId={CREATION_MEDIA_ID} height={PLAYER_HEIGHT} />
    </div>
  );
};
